// src/router/ProtectedOutlet.jsx
//
// Relocated from src/components/ProtectedOutlet.jsx (folder-structure
// cleanup — router-guard/session-bootstrap logic, not a UI component;
// only consumed by AppRoutes.jsx). Ported onto AuthContext's useAuth() +
// GET /auth/me (via authApi.effectivePermissions()) instead of the old
// utils/session-based /users/me polling.
import { useEffect } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { authApi } from "../api/authApi";
import { setLoginError } from "../utils/session";

export default function ProtectedOutlet() {
  const { isAuthenticated, logout } = useAuth();
  const location = useLocation();

  // Revalidates on every navigation — forces a deactivated user out instead
  // of trusting the locally-cached JWT for the rest of its lifetime. Backed
  // by GET /auth/me, which rides the 15-minute effective-permissions cache
  // for global_permissions/accounts/projects but keeps is_active itself
  // live: activate_user()/deactivate_user() both invalidate this cache, so
  // a deactivation is visible here on this very next call, not up to 15
  // minutes later (see effective_permissions_cache.py's _fetch_profile()).
  useEffect(() => {
    if (!isAuthenticated) return;
    authApi
      .effectivePermissions()
      .then(({ data }) => {
        if (!data?.is_active) {
          setLoginError("Your account has been deactivated. Contact admin to reactivate.");
          logout();
        }
      })
      .catch((err) => {
        const status = err?.response?.status;
        if (status === 401 || status === 403) logout();
      });
  }, [isAuthenticated, location.pathname, logout]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
